import api from "./api";

export interface SubscriptionItem {
  id: number;
  name: string;
  description: string | null;
  websites: string[];
  keywords: string[];
  schedule_type: string;
  schedule_time: string | null;
  schedule_day_of_week: number | null;
  cron_expression: string | null;
  status: string;
  last_run_at: string | null;
  next_run_at: string | null;
  report_count: number;
  created_at: string;
}

export interface SubscriptionCreate {
  name: string;
  description?: string;
  websites: string[];
  keywords: string[];
  schedule_type?: string;
  schedule_time?: string;
  schedule_day_of_week?: number;
  cron_expression?: string;
}

export interface SubscriptionUpdate {
  name?: string;
  description?: string;
  websites?: string[];
  keywords?: string[];
  schedule_type?: string;
  schedule_time?: string;
  schedule_day_of_week?: number;
  status?: string;
}

export interface ReportItem {
  id: number;
  subscription_id: number;
  subscription_name: string;
  title: string;
  status: string;
  summary: string | null;
  sources_count: number;
  articles_count: number;
  duration: string | null;
  file_id?: number | null;
  created_at: string;
}

export interface ReportArticle {
  id: number;
  title: string;
  url: string;
  source: string;
  excerpt: string | null;
  relevance: number;
  published_at: string | null;
  crawled_at: string | null;
}

export interface ReportDetail {
  id: number;
  title: string;
  subscription_name: string;
  keywords: string[];
  websites: string[];
  status: string;
  summary: string | null;
  sources_count: number;
  articles_count: number;
  duration: string | null;
  file_id?: number | null;
  markdown?: string | null;
  created_at: string;
  sections: { keyword: string; articles: ReportArticle[] }[];
}

export function listSubscriptions(): Promise<SubscriptionItem[]> {
  return api.get<SubscriptionItem[]>("/subscriptions");
}

export function createSubscription(data: SubscriptionCreate): Promise<SubscriptionItem> {
  return api.post<SubscriptionItem>("/subscriptions", data);
}

export function updateSubscription(id: number, data: SubscriptionUpdate): Promise<SubscriptionItem> {
  return api.put<SubscriptionItem>(`/subscriptions/${id}`, data);
}

export function deleteSubscription(id: number): Promise<void> {
  return api.delete<void>(`/subscriptions/${id}`);
}

export function runSubscription(id: number): Promise<void> {
  return api.post<void>(`/subscriptions/${id}/run`);
}

export function listSubscriptionReports(id: number): Promise<ReportItem[]> {
  return api.get<ReportItem[]>(`/subscriptions/${id}/reports`);
}

export function listAllReports(): Promise<ReportItem[]> {
  return api.get<ReportItem[]>("/subscriptions/reports/all");
}

export function getReportDetail(id: number): Promise<ReportDetail> {
  return api.get<ReportDetail>(`/subscriptions/reports/${id}`);
}
